"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteTable = void 0;
const tslib_1 = require("tslib");
const infinite_react_1 = require("@infinite-table/infinite-react");
Object.defineProperty(exports, "InfiniteTable", { enumerable: true, get: function () { return infinite_react_1.InfiniteTable; } });
tslib_1.__exportStar(require("@infinite-table/infinite-react"), exports);
const env_1 = tslib_1.__importDefault(require("../../env"));
const defaultProps = infinite_react_1.InfiniteTable.defaultProps;
defaultProps.licenseKey = env_1.default.INFINITE_TABLE_LICENSE_KEY;
defaultProps.sortable = false;
defaultProps.rowHeight = '--ab-grid-row-height';
defaultProps.draggableColumns = false;
defaultProps.keyboardNavigation = false;
